


const imageCarousels = document.querySelectorAll(".js-image-carousel");

if (typeof imageCarousels != "undefined" && imageCarousels != null && imageCarousels.length > 0) {

    imageCarousels.forEach((carousel) => {
        const flickity = new Flickity(carousel, {
            cellAlign: "left",
            contain: true,
            draggable: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            cellSelector: ".flex-images__slide",
            resize: true,
            setGallerySize: true,
            lazyLoad: 3
        });
    });

}

const eventCarousels = document.querySelectorAll(".js-events-carousel");

if (typeof eventCarousels != "undefined" && eventCarousels != null && eventCarousels.length > 0) {

    eventCarousels.forEach((carousel) => {
        const flickityOptions = {
            cellAlign: "left",
            contain: true,
            draggable: true,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            cellSelector: ".event-card",
            resize: true,
            setGallerySize: true,
            lazyLoad: 3,
            watchCSS: true,
            on: {
                ready: function() {
                        setSliderHeightToMax(this);
                }
            }
        }

        const flkty = new Flickity(carousel, flickityOptions);

        window.addEventListener('resize', function(){
            setSliderHeightToMax(flkty);
        });

        const prevBtn = carousel.parentNode.querySelector('.js-event-carousel-prev');
        prevBtn.addEventListener("click", (e) => { 
            flkty.previous( false, false );
        });

        const nextBtn = carousel.parentNode.querySelector('.js-event-carousel-next');
        nextBtn.addEventListener("click", (e) => {
            flkty.next( false, false );
        });
    });

  

    function setSliderHeightToMax(slider) {
        slider.cells.forEach(cell => cell.element.style.height = '');
            
        let heights = slider.cells.map(cell => cell.element.offsetHeight),
            max = Math.max.apply(Math, heights);
        
        slider.cells.forEach(cell => cell.element.style.height = max + 'px');
    }

}